import { render, staticRenderFns } from "./BaseActionMenu.vue?vue&type=template&id=64c7ea97"
import script from "./BaseActionMenu.vue?vue&type=script&lang=js"
export * from "./BaseActionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports